import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Main from './pages/Main'; // JSX 컴포넌트로 변경된 파일
import Profile from './pages/Profile';
import Login from './pages/Login';
import Register from './pages/Register';
import NetmarbleCouponPage from './pages/NetmarbleCouponPage';
import MarriageProposal from './pages/MarriageProposal';
import WeddingMain from './pages/wedding/WeddingMain';
import WeddingAdmin from './pages/wedding/WeddingAdmin';
import SenaMain from './pages/sena/SenaMain';
import SenaSiege from './pages/sena/SenaSiege';
import SenaGuideWrite from './pages/sena/SenaGuideWrite';
import SenaExpedition from './pages/sena/SenaExpedition';
import SenaRaid from './pages/sena/SenaRaid';
import SenaRaidSp from './pages/sena/SenaRaidSp';
import SenaGuildWar from './pages/sena/SenaGuildWar';
import SenaTotalWar from './pages/sena/SenaTotalWar';
import SenaTwWrite from './pages/sena/SenaTwWrite';
import SenaGwDeckWrite from './pages/sena/SenaGwDeckWrite';
import SenaGwCounterWrite from './pages/sena/SenaGwCounterWrite';
import SenaLogin from './pages/sena/SenaLogin';
import SenaSignup from './pages/sena/SenaSignup';
import SenaAdmin from './pages/sena/SenaAdmin';
import SenaProfile from './pages/sena/SenaProfile';
import SenaCoupon from './pages/sena/SenaCoupon';
import SenaAuthGuard from './pages/sena/SenaAuthGuard';
import SenaHeroRegister from './pages/sena/SenaHeroRegister';
import SenaGwDefense from './pages/sena/SenaGwDefense';
import SenaGwDefenseWrite from './pages/sena/SenaGwDefenseWrite';

function App() {
    // 청첩장 전용 도메인이면 루트(/)가 청첩장, /admin 은 관리자 페이지
    const isWeddingDomain =
        typeof window !== 'undefined' &&
        window.location.hostname === 'dasol-wooyong-wedding.com';

    if (isWeddingDomain) {
        // ?invite=seal 은 친한 친구용 봉인식 버전, 그 외는 기본 청첩장
        const weddingVariant =
            new URLSearchParams(window.location.search).get('invite') === 'seal' ? 'seal' : 'formal';
        return (
            <Router>
                <Routes>
                    <Route path="/admin" element={<WeddingAdmin />} />
                    <Route path="*" element={<WeddingMain variant={weddingVariant} />} />
                </Routes>
            </Router>
        );
    }

    return (
        <Router>
            <Routes>
                {/* 레이아웃 없이 MarriageProposal 단독 렌더링 */}
                <Route path="/MarriageProposal/" element={<MarriageProposal />} />
                {/* 청첩장 (단독 렌더링) */}
                <Route path="/wedding" element={<WeddingMain />} />
                <Route path="/netmarble/coupon/" element={<NetmarbleCouponPage />} />
                {/* sena 공개 페이지 */}
                <Route path="/sena" element={<SenaMain />} />
                <Route path="/sena/login" element={<SenaLogin />} />
                <Route path="/sena/signup" element={<SenaSignup />} />
                {/* sena 인증 필요 페이지 */}
                <Route path="/sena/siege" element={<SenaAuthGuard><SenaSiege /></SenaAuthGuard>} />
                <Route path="/sena/expedition" element={<SenaAuthGuard><SenaExpedition /></SenaAuthGuard>} />
                <Route path="/sena/raid" element={<SenaAuthGuard><SenaRaid /></SenaAuthGuard>} />
                <Route path="/sena/raid-sp" element={<SenaAuthGuard><SenaRaidSp /></SenaAuthGuard>} />
                <Route path="/sena/guild-war" element={<SenaAuthGuard><SenaGuildWar /></SenaAuthGuard>} />
                <Route path="/sena/guild-war-def" element={<SenaAuthGuard><SenaGwDefense /></SenaAuthGuard>} />
                <Route path="/sena/gw/defense/write" element={<SenaAuthGuard><SenaGwDefenseWrite /></SenaAuthGuard>} />
                <Route path="/sena/total-war" element={<SenaAuthGuard><SenaTotalWar /></SenaAuthGuard>} />
                <Route path="/sena/tw/write" element={<SenaAuthGuard><SenaTwWrite /></SenaAuthGuard>} />
                <Route path="/sena/gw/write" element={<SenaAuthGuard><SenaGwDeckWrite /></SenaAuthGuard>} />
                <Route path="/sena/gw/counter/write" element={<SenaAuthGuard><SenaGwCounterWrite /></SenaAuthGuard>} />
                <Route path="/sena/guide/write" element={<SenaAuthGuard><SenaGuideWrite /></SenaAuthGuard>} />
                <Route path="/sena/admin" element={<SenaAuthGuard><SenaAdmin /></SenaAuthGuard>} />
                <Route path="/sena/admin/hero" element={<SenaAuthGuard><SenaHeroRegister /></SenaAuthGuard>} />
                <Route path="/sena/profile" element={<SenaAuthGuard><SenaProfile /></SenaAuthGuard>} />
                <Route path="/sena/coupon" element={<SenaAuthGuard><SenaCoupon /></SenaAuthGuard>} />
                {/* 그 외 모든 경로는 Layout으로 감싸기 */}
                <Route
                  path="*"
                  element={
                    <Layout>
                        <Routes>
                            <Route path="/" element={<Main />} />
                            <Route path="/profile/:summonerName" element={<Profile />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                        </Routes>
                    </Layout>
                  }
                />
            </Routes>
        </Router>
    );
}


export default App;